<div class="monthly-balances-dashboard">
  <!-- Toast Messages -->
  <p-toast></p-toast>
  
  <!-- Loading State -->
  <div *ngIf="state.loading" class="loading-container">
    <p-progressSpinner></p-progressSpinner>
    <p>Cargando saldos mensuales...</p>
  </div>

  <!-- Dashboard Content -->
  <div *ngIf="!state.loading">
    <!-- Monthly Matrix Table -->
    <div class="table-section">
      <div class="card-style">
        <div class="table-header-bar">
          <div class="header-section">
            <div class="section-title-container mb-3">
                <h3 class="section-title">
                <i class="fas fa-calendar-alt mr-2"></i>
                Saldos Mensuales por Arrendamiento
                </h3>
                <p class="section-subtitle" *ngIf="state.data">
                    Período: {{state.data.rangoAnalisis.fechaInicio | date:'MMM yyyy'}} - {{state.data.rangoAnalisis.fechaFin | date:'MMM yyyy'}} | 
                    Total: {{state.data.rangoAnalisis.totalArrendamientos}} Arrendamientos
                </p>
            </div>
          </div>

          <div class="flex gap-2">
              <div class="search-input">
                <i class="pi pi-search"></i>
                <input 
                  type="text" 
                  pInputText 
                  [(ngModel)]="globalFilter"
                  (input)="onGlobalFilterChange()"
                  placeholder="Buscar por cliente o folio...">
              </div>
              
              <p-button 
                icon="pi pi-file-excel" 
                [text]="true"
                [rounded]="true"
                severity="success"
                (onClick)="exportToExcel()"
                pTooltip="Exportar a Excel"
                tooltipPosition="top"
                class="action-btn">
              </p-button>
              
              <p-button 
                icon="pi pi-refresh" 
                [text]="true"
                [rounded]="true"
                severity="info"
                (onClick)="refresh()"
                pTooltip="Actualizar datos"
                tooltipPosition="top"
                class="action-btn">
              </p-button>
          </div>
        </div>

        <!-- Monthly Matrix Table -->
        <div class="matrix-table-wrapper">
          <table class="monthly-matrix-table" *ngIf="filteredLeases.length > 0">
            <thead>
              <tr>
                <th class="folio-column sticky-left">Cliente / Folio</th>
                <th 
                  class="month-column" 
                  *ngFor="let month of monthColumns"
                  [title]="month.fullName">
                  {{month.label}}
                </th>
                <th class="actions-column">Acciones</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let lease of filteredLeases; trackBy: trackByLeaseId" class="matrix-row">
                <td class="folio-cell sticky-left">
                  <div class="client-folio-container">
                    <div class="client-name" [title]="lease.client">
                      {{lease.client}}
                    </div>
                    <span 
                      class="folio-badge clickeable" 
                      (click)="navigateToLease(lease)"
                      [title]="'Ir a arrendamiento ' + lease.folio">
                      {{lease.folio}}
                    </span>
                  </div>
                </td>
                <td 
                  class="month-cell" 
                  *ngFor="let month of monthColumns"
                  [ngClass]="getPaymentStatus(lease, month.key)">
                  <div 
                    class="payment-indicator"
                    [ngClass]="getPaymentStatus(lease, month.key)"
                    (click)="showDetail(lease, month.key)"
                    [title]="getTooltipText(lease, month.key)">
                    <span class="payment-icon">{{getPaymentIcon(lease, month.key)}}</span>
                    <div class="payment-amount" *ngIf="lease.monthlyPayments[month.key]">
                      <small>${{formatCompactAmount(lease.monthlyPayments[month.key]?.montoPagado || 0)}}</small>
                    </div>
                  </div>
                </td>
                <td class="actions-cell">
                  <div class="action-buttons">
                    <p-button 
                      icon="pi pi-eye" 
                      [text]="true" 
                      [rounded]="true"
                      size="small"
                      severity="info"
                      (onClick)="showLeaseDetail(lease)"
                      pTooltip="Ver desglose completo"
                      tooltipPosition="top">
                    </p-button>
                  </div>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr class="totals-row">
                <td class="totals-label sticky-left">
                  <div class="totals-container">
                    <strong>TOTAL MENSUAL</strong>
                    <small>Rentas programadas</small>
                  </div>
                </td>
                <td 
                  class="total-cell" 
                  *ngFor="let month of monthColumns">
                  <div class="total-amount">
                    {{formatTotalAmount(monthlyTotals[month.key] || 0)}}
                  </div>
                </td>
                <td class="total-actions">-</td>
              </tr>
            </tfoot>
          </table>
          
          <div *ngIf="filteredLeases.length === 0 && !state.loading" class="no-data-matrix">
            <i class="fas fa-table fa-3x text-muted mb-3"></i>
            <h4>No hay datos disponibles</h4>
            <p>No se encontraron arrendamientos que coincidan con los filtros aplicados.</p>
          </div>
        </div>

        <!-- Matrix Legend -->
        <div class="matrix-legend mt-3">
          <h5>Leyenda de Estados:</h5>
          <div class="legend-items">
            <div class="legend-item">
              <span class="legend-icon paid-complete">✅</span>
              <span>Pagado Completo</span>
            </div>
            <div class="legend-item">
              <span class="legend-icon paid-partial">⚠️</span>
              <span>Pago Parcial</span>
            </div>
            <div class="legend-item">
              <span class="legend-icon paid-anticipated">💰</span>
              <span>Pago Anticipado</span>
            </div>
            <div class="legend-item">
              <span class="legend-icon unpaid">❌</span>
              <span>Sin Pago</span>
            </div>
            <div class="legend-item">
              <span class="legend-icon overdue">🔴</span>
              <span>Vencido</span>
            </div>
            <div class="legend-item">
              <span class="legend-icon no-period">⚪</span>
              <span>Sin Período</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Detail Modal -->
  <p-dialog 
    header="Detalle del Período" 
    [(visible)]="displayDetailModal" 
    [modal]="true" 
    [style]="{width: '70vw', maxWidth: '600px'}"
    [closable]="true">
    
    <!-- Single Period Detail -->
    <div *ngIf="state.selectedLease && state.selectedPeriod">
      <div class="detail-modal-header mb-4">
        <h4 class="mb-2">{{state.selectedLease.folio}} - {{state.selectedMonth}}</h4>
        <div class="flex gap-3">
          <p-tag 
            severity="info" 
            [value]="'Período: #' + state.selectedPeriod.periodo">
          </p-tag>
          <p-tag 
            [severity]="getPeriodiStatusSeverity(state.selectedPeriod)"
            [value]="'Estado: ' + getPeriodiStatusText(state.selectedPeriod)">
          </p-tag>
        </div>
      </div>

      <div class="payment-breakdown">
        <div class="payment-row">
          <div class="payment-label">
            <i class="fas fa-dollar-sign text-primary mr-2"></i>
            <span>Monto por Pagar:</span>
          </div>
          <div class="payment-value">
            <strong>{{state.selectedPeriod.montoPorPagar | currency:'MXN':'symbol':'1.2-2'}}</strong>
          </div>
        </div>

        <div class="payment-row">
          <div class="payment-label">
            <i class="fas fa-check-circle text-success mr-2"></i>
            <span>Monto Pagado:</span>
          </div>
          <div class="payment-value">
            <strong>{{state.selectedPeriod.montoPagado | currency:'MXN':'symbol':'1.2-2'}}</strong>
          </div>
        </div>

        <div class="payment-row total-row" [ngClass]="{'debt': getSaldoPendiente() > 0, 'paid': getSaldoPendiente() === 0}">
          <div class="payment-label">
            <i class="fas fa-exclamation-triangle mr-2" *ngIf="getSaldoPendiente() > 0"></i>
            <i class="fas fa-check-circle mr-2" *ngIf="getSaldoPendiente() === 0"></i>
            <span>Saldo Pendiente:</span>
          </div>
          <div class="payment-value">
            <strong>{{getSaldoPendiente() | currency:'MXN':'symbol':'1.2-2'}}</strong>
          </div>
        </div>
      </div>

      <div class="modal-actions mt-4">
        <p-button 
          label="Ver Historial" 
          icon="pi pi-history"
          severity="secondary"
          [outlined]="true"
          class="mr-2"
          (onClick)="showViewHistoryMessage()">
        </p-button>
        <p-button 
          label="Registrar Pago" 
          icon="pi pi-plus"
          severity="success"
          *ngIf="getSaldoPendiente() > 0"
          (onClick)="showRegisterPaymentMessage()">
        </p-button>
      </div>
    </div>

    <!-- Lease Summary Detail -->
    <div *ngIf="state.selectedLease && !state.selectedPeriod">
      <div class="detail-modal-header mb-4">
        <h4 class="mb-2">Resumen Completo - {{state.selectedLease.folio}}</h4>
        <div class="flex gap-3">
          <p-tag 
            severity="info" 
            [value]="'Total Períodos: ' + state.selectedLease.saldosPorMes.length">
          </p-tag>
          <p-tag 
            [severity]="getAmountSeverity(getSelectedLeaseTotalPendiente())"
            [value]="'Pendiente: ' + (getSelectedLeaseTotalPendiente() | currency:'symbol':'1.0-0')">
          </p-tag>
        </div>
      </div>

      <!-- Summary Cards -->
      <div class="summary-cards mb-4">
        <div class="summary-card paid">
          <div class="card-icon">
            <i class="fas fa-check-circle"></i>
          </div>
          <div class="card-content">
            <div class="card-amount">{{getSelectedLeaseTotalPagado() | currency:'symbol':'1.0-0'}}</div>
            <div class="card-label">Total Pagado</div>
          </div>
        </div>
        
        <div class="summary-card pending">
          <div class="card-icon">
            <i class="fas fa-exclamation-triangle"></i>
          </div>
          <div class="card-content">
            <div class="card-amount">{{getSelectedLeaseTotalPendiente() | currency:'symbol':'1.0-0'}}</div>
            <div class="card-label">Total Pendiente</div>
          </div>
        </div>
      </div>

      <!-- Periods Table -->
      <div class="periods-table">
        <h5>Detalle por Período</h5>
        <p-table [value]="state.selectedLease.saldosPorMes" styleClass="p-datatable-sm">
          <ng-template pTemplate="header">
            <tr>
              <th>Período</th>
              <th>Mes</th>
              <th>Por Pagar</th>
              <th>Pagado</th>
              <th>Pendiente</th>
              <th>Estado</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-periodo>
            <tr>
              <td><strong>#{{periodo.periodo}}</strong></td>
              <td>{{periodo.mes}}</td>
              <td>{{periodo.montoPorPagar | currency:'symbol':'1.0-0'}}</td>
              <td>{{periodo.montoPagado | currency:'symbol':'1.0-0'}}</td>
              <td>{{(periodo.montoPorPagar - periodo.montoPagado) | currency:'symbol':'1.0-0'}}</td>
              <td>
                <p-tag 
                  [severity]="getPeriodiStatusSeverity(periodo)"
                  [value]="getPeriodiStatusText(periodo)">
                </p-tag>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>

      <div class="modal-actions mt-4">
        <p-button 
          label="Ver Arrendamiento" 
          icon="pi pi-external-link"
          severity="secondary"
          [outlined]="true"
          (onClick)="navigateToSelectedLease()"
          class="mr-2">
        </p-button>
        <p-button 
          label="Exportar Detalle" 
          icon="pi pi-file-excel"
          severity="success"
          [outlined]="true"
          (onClick)="exportSelectedLeaseDetail()">
        </p-button>
      </div>
    </div>
  </p-dialog>

</div>
